// Bet amounts are whole in-game dollars. Players type them the short way: 50k, 2.5m, 1b, 3t.

const SUFFIXES: Record<string, number> = {
    k: 1_000,
    m: 1_000_000,
    b: 1_000_000_000,
    t: 1_000_000_000_000
}

const fullFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

export function parseAmount(input: string): number | null {
    const cleaned = input.trim().toLowerCase().replace(/[$,\s_]/g, '')
    const match = /^(\d+(?:\.\d+)?|\.\d+)([kmbt])?$/.exec(cleaned)

    if (!match) return null

    const value = Number(match[1]) * (match[2] ? SUFFIXES[match[2]] : 1)

    if (!Number.isFinite(value) || value <= 0) return null

    return Math.floor(value)
}

function trimDecimals(value: number): string {
    const truncated = Math.floor(value * 100) / 100

    return truncated.toFixed(2).replace(/\.?0+$/, '')
}

// $19.6K, $2.5M, $15B
export function formatShort(value: number): string {
    const sign = value < 0 ? '-' : ''
    const abs = Math.abs(value)

    if (abs >= 1e12) return `${sign}$${trimDecimals(abs / 1e12)}T`
    if (abs >= 1e9) return `${sign}$${trimDecimals(abs / 1e9)}B`
    if (abs >= 1e6) return `${sign}$${trimDecimals(abs / 1e6)}M`
    if (abs >= 1e3) return `${sign}$${trimDecimals(abs / 1e3)}K`

    return `${sign}$${Math.floor(abs)}`
}

// $10,000
export function formatFull(value: number): string {
    const sign = value < 0 ? '-' : ''

    return `${sign}$${fullFormatter.format(Math.abs(Math.floor(value)))}`
}

// 10k, 2.5m: the compact form the bet box shows after ½, 2×, Min and Max
export function formatInput(value: number): string {
    const units: Array<[number, string]> = [[1e12, 't'], [1e9, 'b'], [1e6, 'm'], [1e3, 'k']]

    for (const [size, suffix] of units) {
        if (value >= size) {
            const short = `${trimDecimals(value / size)}${suffix}`

            return parseAmount(short) === value ? short : String(value)
        }
    }

    return String(value)
}

export function formatMultiplier(value: number): string {
    return `${(Math.floor(value * 100) / 100).toFixed(2)}×`
}
